import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { AttachmentFullViewState, ActionType } from 'owa-attachment-full-data';
import { InlineAttachmentStatus } from 'owa-attachment-well-data';

export default function hasPendingAttachments(
    attachmentWellViewState: AttachmentWellViewState
): boolean {
    return (
        hasPendingAttachment(attachmentWellViewState.docViewAttachments) ||
        hasPendingAttachment(attachmentWellViewState.imageViewAttachments) ||
        hasPendingInlineAttachment(attachmentWellViewState)
    );
}

function hasPendingAttachment(attachments: AttachmentFullViewState[]): boolean {
    return attachments.some(attachment => attachment.ongoingAction !== ActionType.None);
}

function hasPendingInlineAttachment(attachmentWellViewState: AttachmentWellViewState): boolean {
    return attachmentWellViewState.inlineAttachments.some(
        attachment => attachment.status === InlineAttachmentStatus.Initialized
    );
}
